module.exports = __webpack_public_path__ + "static/media/Soaps.63d9a0e7.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/buttons/Soaps.PNG
// module id = 64
// module chunks = 0